import api, { QueryStringParameters } from "../api";

export interface NewsletterSubscribeResponse {
  success: boolean;
  message?: string;
  data?: any;
}

const newsletterApi = api.injectEndpoints({
  endpoints: (build) => ({
    subscribeNewsletter: build.mutation({
      query: ({
        body,
        params,
      }: {
        body: { email: string };
        params?: QueryStringParameters;
      }) => ({
        url: `newsletter/subscribe`,
        method: "POST",
        body,
        params,
      }),
      transformResponse(baseQueryReturnValue: NewsletterSubscribeResponse) {
        return baseQueryReturnValue;
      },
    }),
  }),
});

export const { useSubscribeNewsletterMutation } = newsletterApi;

export default newsletterApi;
